import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AppRootActionMenuButton,
  ArtefactMode,
  Environments,
  BreadcrumbsProvider,
  SelectedArtefactType,
  AppProvider,
  DependentArtefactsFlyout
} from "@emisgroup/cohort-builder-kit";
import { useUser } from "../../AuthContext";
import { IRootState } from "../../reducer/CombineReducer";
import { PartitionList } from "./Partition/Partition.logic";
import { FinancialSlice } from "./FinancialYearList";
import LeftPanelCollapsedView from "./LeftPanelCollapsed.view";
import ExtractAddDialog from "./ExtractAdd/ExtractAddDialog.logic";
import { FEASIBILITY_APP_ID } from "./Constant";
import { PartitionListSlice } from "./Partition";
import { ExtractListSlice } from "./ExtractList";
import ChevronLeft from "~icons/ic/outline-chevron-left";
import "./Style.scss";

/**
 * Responsible for rendering the left panel component
 */
const LeftPanelView: React.FC = () => {

  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const { artefacts } = useSelector((state: IRootState) => state.partition);
  const dispatch = useDispatch();
  const { user } = useUser();

  // Handler for collapsing the left hand panel
  const collapse = (): void => {
    setIsCollapsed(!isCollapsed);
    dispatch(FinancialSlice.actions.setCollapsedView(!isCollapsed));
  };

  const sideBarClass = isCollapsed ? "collapsed" : "expanded";

  /**
   * Responsible for rendering the left panel component
   */
  const handleChosenArtefact = (artefact: SelectedArtefactType): void => {
    dispatch(PartitionListSlice.actions.setSelectedId(artefact?.id));
    dispatch(ExtractListSlice.actions.setDashBoardName(artefact?.name));
  };

  const setArtefactList = (data: SelectedArtefactType[]): void => {
    dispatch(PartitionListSlice.actions.setPartitionList(data));
  };

  return (
    <>
      <div className={`ebt-leftpanel ebt-leftpanel--${sideBarClass}`}>
        <div className="ebt-leftpanel__headerSection">
          <div className="ebt-leftpanel__headerButton">
            <AppRootActionMenuButton
              applicationId={FEASIBILITY_APP_ID}
              mode={ArtefactMode.ASSESSMENT}
              env={process.env.APP_TARGET_ENV as Environments}
              accessToken={user?.token}
              artefactData={artefacts}
              chosenArtefact={handleChosenArtefact}
              setPartitionList={setArtefactList}
            />
            <ExtractAddDialog isIconOnly={!isCollapsed} />
          </div>
          <div className="expand-collapse-icon__container-expand">
            <ChevronLeft className="expand-collapse-icon" title="Collapse" onClick={collapse} />
          </div>
        </div>
        <BreadcrumbsProvider>
          <AppProvider>
            <PartitionList artefactId={FEASIBILITY_APP_ID} />
            <DependentArtefactsFlyout />
          </AppProvider>
        </BreadcrumbsProvider>
      </div>
      <LeftPanelCollapsedView onClick={collapse} isCollapsed={isCollapsed} />
    </>
  );
};

export default LeftPanelView;
